// lot store inner constants

export const ACT_LOAD_SIGNATURES = 'loadSignatures';

export const MUT_SAVE_SIGNATURES = 'saveSignatures';
export const MUT_CLEAR_SIGNATURES = 'clearSignatures';

export const GET_SIGNATURES = 'getSignatures';
